import { connect } from 'react-redux';
import { PreviewBuilder } from './previewbuilder';
import { getComponets } from './selectors';
import { FormBuilder } from './formbuilder';
const mapStateToProps = (state, { pageNum }) => ({
    pageNum,
    components: getComponets(state),
});
export const PreviewBuilderContainer = connect(mapStateToProps)(PreviewBuilder);
export const FormBuilderContainer = connect(mapStateToProps)(FormBuilder);
//# sourceMappingURL=container.js.map